import CloseIcon from "@/assets/CloseIcon";
import { useI18nContext } from "@/hooks/useI18nContext";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect } from 'react';
import { toast } from "react-toastify";

declare var Calendly: {
  initInlineWidget: (options: {
    url: string;
    parentElement: HTMLElement | null;
  }) => void;
};

export const ModalWithCalendly = ({
  showModal,
  onClose,
  userEmail,
  userName,
  MobileNumber,
}: {
  showModal: boolean;
  onClose: () => void;
  userEmail: string;
  userName: string;
  MobileNumber: string;
}) => {
  const router = useRouter(); 
  const path = usePathname();
  const isUsLocale = useI18nContext().locale === "us";
  const isEnLocale = useI18nContext().locale === "en";
  useEffect(() => {
    if (showModal) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      script.onerror = () => console.error("Failed to load Calendly script");

      script.onload = () => {
        console.log("Calendly script loaded successfully");

       
        Calendly.initInlineWidget({
          url: `https://calendly.com/d/cp37-gbb-3gn/meet-with-graphy-expert?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=2a2861&email=${encodeURIComponent(userEmail)}&name=${encodeURIComponent(userName)}&MobileNumber=${encodeURIComponent(MobileNumber)}`,
          parentElement: document.getElementById('calendly-div')
        });
      };

      
      const handleCalendlyMessage = (event: MessageEvent) => {
        if (event.origin === 'https://calendly.com') {
          const data = event.data;
          if (data.event === 'calendly.event_scheduled') {
            window.history.pushState({}, '', window.location.href + 'success');
            if(path.includes("/online-course-platform/")){
              toast.success("Submitted successfully.");
            }
          }
        }
      };

      window.addEventListener('message', handleCalendlyMessage);

      return () => {
        document.body.removeChild(script);
        window.removeEventListener('message', handleCalendlyMessage);
      };
    }
  }, [showModal, userEmail, userName, MobileNumber, router]);

  const calendlyUrl = `https://calendly.com/d/cp37-gbb-3gn/meet-with-graphy-expert?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=2a2861&email=${encodeURIComponent(userEmail)}&name=${encodeURIComponent(userName)}&MobileNumber=${encodeURIComponent(MobileNumber)}`;
  const calendlyUrlEn = `https://calendly.com/d/ygy-j3b-r7t/graphy-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=2a2861&email=${encodeURIComponent(userEmail)}&name=${encodeURIComponent(userName)}&MobileNumber=${encodeURIComponent(MobileNumber)}`;
  return showModal ? (
    <div
      className="fixed inset-0 z-modalOverlay w-full bg-black bg-opacity-50 md:inset-0 md:flex md:items-center md:justify-center "
      onClick={onClose}
    >
      <div
        className="absolute bottom-5 left-0 right-0 flex flex-col gap-6 rounded-t-3xl bg-white p-4 md:static md:w-[900px] md:rounded-3xl md:p-6 my-0"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center">
          <h2 className="text-xl mb-0 my-0">Schedule a Demo</h2>
          <CloseIcon onClick={onClose} />
        </div>
        <div
          id="calendly-div"
          className="calendly-inline-widget fixed my-0 w-full h-[65vh] md:h-screen xl:h-[700px] mx-auto max-w-full overflow-hidden"
          data-url={isUsLocale ? calendlyUrl : calendlyUrlEn}
        ></div>
      </div>
    </div>
  ) : null;
};
